import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useRole } from '@/hooks/useRole';

const RepRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, loading } = useAuth();
  const { isRep, isAdmin, isLoading } = useRole();

  if (loading || isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  // Admins can also view rep area for support purposes.
  if (!isRep && !isAdmin) return <Navigate to="/dashboard" replace />;

  return <>{children}</>;
};

export default RepRoute;
